/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Link_Social_DescriptionInputs */

const en_profile_link_social_description = /** @type {(inputs: Profile_Link_Social_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link your social accounts to quickly sign in to Listening.`)
};

const es_profile_link_social_description = /** @type {(inputs: Profile_Link_Social_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincula tus cuentas sociales para iniciar sesión rápidamente en Listening.`)
};

/**
* | output |
* | --- |
* | "Link your social accounts to quickly sign in to Listening." |
*
* @param {Profile_Link_Social_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_link_social_description = /** @type {((inputs?: Profile_Link_Social_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Link_Social_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_link_social_description(inputs)
	return en_profile_link_social_description(inputs)
});